import { useTraccarMessage } from './useTraccarSocket';
import { useEventsStore } from '@/stores/events';
import { playNotificationSound } from '@/lib/sound';

/**
 * Acumula no store persistente todos os eventos que chegam via WebSocket do
 * Traccar e toca som de notificação se habilitado. Monte uma vez no layout
 * (AppLayout). Os eventos ficam disponíveis em `useEventsStore`.
 */
export function useEventsCollector() {
  const push = useEventsStore((s) => s.push);

  useTraccarMessage((msg) => {
    if (!msg.events?.length) return;
    push(msg.events);
    void playNotificationSound();
  });
}
